import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

export const reportsContract = c.router({
  getReports: {
    method: 'GET',
    path: '/reports',
    responses: {
      200: z.object({ data: z.object({ reports: z.array(z.any()) }) }),
    },
  },
  deleteReport: {
    method: 'DELETE',
    path: '/reports/:reportId',
    pathParams: z.object({ reportId: z.string() }),
    body: c.noBody(),
    responses: {
      204: z.undefined(),
    },
  },
  downloadReport: {
    method: 'POST',
    path: '/reports/download/:reportId',
    pathParams: z.object({ reportId: z.string() }),
    body: c.noBody(),
    responses: {
      200: c.otherResponse({
        contentType: 'application/octet-stream',
        body: z.any(),
      }),
      404: z.object({ message: z.string() }),
    },
  },
});
